<template>
  <div id="left" class="col-md-3 col-xs-12 wow bounceInLeft">
    <div class="typetile">
      <div class="typetile-left">{{ title.toUpperCase() }}</div>
      <div class="typetile-rigth">
        <img src="../assets/hhdimg/type1.png" />
      </div>
    </div>
    <div class="typemenu">
      <el-menu
        :default-active="String(active)"
        class="el-menu-vertical-demo"
        unique-opened
        @select="selectMenu"
      >
        <Submenu
          :list="typelist"
          :selectItem="active"
          @selectTop="selectMenu"
        ></Submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
import Submenu from "./Submenu";
export default {
  name: "Navimg",
  data() {
    return {};
  },
  components: {
    Submenu,
  },
  props: {
    typelist: Array,
    title: String,
    active: String,
  },
  methods: {
    selectMenu(e) {
      this.$emit("selectType", e);
    },
  },
};
</script>

<style>
.typetile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  background: linear-gradient(to bottom, #0c74b5 0%, #288fca 100%);
}
.typetile-left {
  font-size: 30px;
  padding: 5px;
  font-weight: bold;
  color: #fff;
}
.typetile-rigth {
  padding: 15px;
  width: 45px;
  height: 45px;
  border: 1px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  border-radius: 50%;
}
.typetile-rigth img {
  width: 30px;
  height: 30px;
}
.typemenu {
  background-color: #fff;
}

.el-menu .el-menu-item,
.el-submenu {
  border-bottom: 1px solid #ebebeb; /* 给每个菜单项之间添加分隔线 */
  text-align: center;
}

.el-menu-item:last-child {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Typeleft.vue